module.exports = __webpack_public_path__ + "img/jm404.fd60203c.png";